export interface WidgetSettings {
  font_size: number
  contrast: string | false
  large_cursor: boolean
  reading_guide: boolean
  screen_reader: boolean
  dyslexia_font: boolean
}

/**
 * Emits a tracking event from the accessibility widget.
 * The host application listens for 'asw:track' CustomEvents
 * and dispatches them to the existing Satu Event + GA tracker.
 */
export function emitTrack(action: string, settings?: WidgetSettings): void {
  window.dispatchEvent(
    new CustomEvent('asw:track', {
      detail: { action, settings },
    }),
  )
}
